// extracted by mini-css-extract-plugin
export default {"field":"LobbyNicknameField_field__AEH4R","label":"LobbyNicknameField_label__FyoEt","input":"LobbyNicknameField_input__EQRON","hint":"LobbyNicknameField_hint__6D-u+"};